<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <!-- <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img :src="require('@/assets/images/logo/ruino/logo.jpg')" class="sidebar-logo" style="width: 56px;height: 13px">
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img :src="require('@/assets/images/logo/ruino/logo.jpg')" class="sidebar-logo" style="width: 167px;height: 39px">
      </router-link> -->
    </transition>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SidebarLogo',
    computed:{
        ...mapGetters([
            'title',"logo"
        ]),
    },
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 110%;
  height: 70px;
  line-height: 85px;
  background: #fff;
  text-align: center;
  overflow: hidden;
  padding-top: 10px;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 40px;
      height: 40px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #000;
      font-weight: 600;
      line-height: 50px;
      font-size: 17px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
